import React, {useState, useContext, useRef, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import ContentModal from './ContentModal';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Web3 from "web3";
import Context from "../../../context/context";
import Swal  from "sweetalert2";
import Staking from '../abi/Staking.json';
import DEXRouter from '../abi/Router.json';
import pTGC from '../abi/Ptgc.json';
import { formatUnits, parseUnits } from "ethers";
import TransactionStatus from "../TxnStatus";
import { sendPostRequest, sendGetRequest, txAfterDone, txDone, txStart, truncateAddress } from '../../../helper/Helper';

const Sections2 = () => {
  const {account, onConnect, providers, pTGCVolume, ptgcPrice, ufoPrice, plsPrice } = useContext(Context);
  const { ref, inView } = useInView({ triggerOnce: true });
  const [isOpen, setIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("leaderboard");
  const [PLSBalance, setPLSBalance] = useState(0);
  const [PTGCBalance, setPTGCBalance] = useState(0);
  const [PLSAmount, setPLSAmount] = useState('');
  const [PTGCAmount, setPTGCAmount] = useState('');
  const [sponsorName, setSponsorName] = useState('');
  const [sponsorWallet, setSponsorWallet] = useState('');
  const [myName, setMyName] = useState('');
  const [userName, setUserName] = useState('');
  const [open, setOpen] = useState(false);
  const [slippage, setSlippage] = useState(6);
  const dropdownRefSetting = useRef(null);
  const baseurl = "https://goptgc.com/#/ptgc-onboarding?referid=";

  function validateReferralCode(code) {
    return /^[a-zA-Z0-9_@\$&-]{3,20}$/.test(code);
  }

  function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
      const storedSponsorCode = localStorage.getItem("sponserCode");
      const urlCode = getParameterByName("referid");

      if (urlCode && validateReferralCode(urlCode)) {
          setSponsorName(urlCode);
          localStorage.setItem("sponserCode", urlCode);
      } else if (storedSponsorCode && validateReferralCode(storedSponsorCode)) {
          setSponsorName(storedSponsorCode);
      } else {
          localStorage.removeItem("sponserCode");
      }
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openModalWithTab = (tab) => {
    setActiveTab(tab);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(sponsorWallet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {}
  };

  useEffect(() => {
    if(account) {
      getData();
    }
  }, [account]);

  useEffect(() => {
    handleToAmountChange();
  }, [PLSAmount]);

  const getData = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);

    setPLSBalance(Number(formatUnits(await web3.eth.getBalance(account), 18)));
    setPTGCBalance(Number(formatUnits(await pTGCContract.methods.balanceOf(account).call(), 18)));

    try {
        const response = await sendGetRequest(`referral?wallet=${account}`);
        if (response && response.status === 200) {
              if(response.data.user && response.data.user.username) {
                setMyName(response.data.user.username);
              } else {
                setMyName('');
              }
            if (response.data.sponsor && response.data.sponsor.sponsor_username) {
              setSponsorName(response.data.sponsor.sponsor_username);
              setSponsorWallet(response.data.sponsor.sponsor_wallet);
            } else {
                if (sponsorName != "") {
                  const responseSponsor = await sendGetRequest(`referral?username=${sponsorName}`);
                  if (responseSponsor && responseSponsor.status === 200) {
                    setSponsorName(responseSponsor.data.user.username);
                    setSponsorWallet(responseSponsor.data.user.wallet);
                  } else {
                    setSponsorName('');
                    setSponsorWallet('');
                  }
                }
            }
        } else {
            setMyName('');
            if (sponsorName != "") {
                const responseSponsor = await sendGetRequest(`referral?username=${sponsorName}`);
                if (responseSponsor && responseSponsor.status === 200) {
                  setSponsorName(responseSponsor.data.user.username);
                  setSponsorWallet(responseSponsor.data.user.wallet);
                } else {
                  setSponsorName('');
                  setSponsorWallet('');
                }
            } else {
              setSponsorName('');
              setSponsorWallet('');
            }
        }
    } catch (error) {}
  }

  const handleToAmountChange = () => {
    if (!isNaN(parseFloat(PLSAmount))) {
      const pTGC_TRANSFER_FEE = 0;
      const PLATFORM_FEE = 0;    
      const estimatedInput = (parseFloat(PLSAmount) * plsPrice) / (1 - pTGC_TRANSFER_FEE) / (1 - PLATFORM_FEE) / ptgcPrice;
      setPTGCAmount(estimatedInput.toLocaleString('en-US', { maximumFractionDigits: 2 }));
    }
  };

  const swapPTGC = async () => {
      const web3 = new Web3(providers);
      const routerContract = new web3.eth.Contract(DEXRouter.ABI, DEXRouter.Contract);
      const amount = parseUnits(String(PLSAmount || "0"), 18);
      const deadline = Math.floor(Date.now() / 1000) + 60 * 60;
      const WPLS = '0xA1077a294dDE1B09bB078844df40758a5D0f9a27';
      const path = [WPLS, pTGC.Contract];

      try {
          const amounts = await routerContract.methods.getAmountsOut(amount, path).call();
          const expectedOut = parseInt(amounts[1]);
          const slippageOutput = (expectedOut * slippage) / (100);
          const minOutput = (expectedOut - slippageOutput);

          await routerContract.methods.swapExactETHForTokensSupportingFeeOnTransferTokens(minOutput, path, account, deadline).send({
              from: account,
              value: amount,
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                  title: "Please try again",
                  text: error.message,
                  icon: "error",
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                  showCloseButton: true,
                  customClass: {
                      confirmButton: "btn btn-danger"
                  }
              });
          }).then(function(receipt) {
              if(sponsorName !=="" && parseInt(receipt.status) === 1) {
                submitData(receipt.transactionHash);
              } else {
                txDone()
                setTimeout(() => {
                  txAfterDone()
                }, 2000)
              }
              getData();
          });
      } catch (error) {
          txDone();
          txAfterDone();
          Swal.fire({
              title: "Please try again",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Ok",
              showCloseButton: true,
              customClass: {
                  confirmButton: "btn btn-danger"
              }
          });
      }
  }

  const submitData = async (transactionHash) => {
    try {
        const response = await sendPostRequest({referred_username: sponsorName, wallet_address_buyer: account, from_amount: PLSAmount * plsPrice, type: 'PTGC', transaction_hash: transactionHash}, '/api/auth/referral/buy');
        txDone()
        setTimeout(() => {
            txAfterDone()
        }, 2000)
    } catch (error) {
          txDone();
          txAfterDone();
          Swal.fire({
              title: "Error Found",
              text: 'Something went wrong, please try again',
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Close",
              customClass: {
                  confirmButton: "btn-danger"
              }
          });
      }
  }

  const generateLink = async () => {
    if (!userName.trim()) {
      Swal.fire({
          title: "Error Found",
          text: 'Username is required',
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
      });
    } else {
      try {
          const response = await sendPostRequest({username: userName, wallet: account}, '/api/auth/referral/submit');
          if (response && response.status === 200) {
            Swal.fire({
                title: "Referral link generated successfully",
                text: 'Thanks for waiting',
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Close",
                customClass: {
                  confirmButton: "btn-danger"
                }
            });
            await getData();
          } else if (response) {
            Swal.fire({
                title: "Error Found",
                text: response.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Close",
                customClass: {
                    confirmButton: "btn-danger"
                }
            });
          }
      } catch (error) {
          Swal.fire({
              title: "Error Found",
              text: 'Something went wrong, please try again',
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Close",
              customClass: {
                  confirmButton: "btn-danger"
              }
          });
      }
    }
  }
return (
  <>
  <section className="boXSec StatisticsSec5  boXSecUp padsec pt-0 PTGCSEC">
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="statsSN subcontent " data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1600">
            <h2 className="mb-1 gradient-stroke-text">PTGC Videos</h2>
            <p className="mb-0">Explore our curated playlist of educational videos that dive into PTGC, its innovative value generation system, and practical tips for interacting with the dApp and calculators.</p>
            <div className="mt-4 pt-2">
              <div className="someBtnsmod100 someBtns SRTOP row">
                <div className="col-12">
                  <button onClick={() => openModalWithTab("videos")} className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4">
                    <span>View Now</span> 
                    <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="statsSN subcontent snX3 snX" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1200">
            <h2 className="gradient-stroke-text">Need help getting pTGC?</h2>
            <p className="mb-0">Check out our comprehensive guide on how to buy PTGC, complete with helpful links, a detailed step-by-step walkthrough, and supporting videos.</p>
            <div className="">
              <div className="someBtnsmod100 someBtns SRTOP row">
                <div className="col-12">
                  <button onClick={() => openModalWithTab("help")} className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-5"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-lg-4">
          <div className="snXBig snXBig2 " data-aos="fade" data-aos-delay="1000" data-aos-duration="800">
            <div className="statsSN subcontent snXIn snX mb-0 text-start ">
                <div>
                    <h2 className="mt-2 mb-1 gradient-stroke-text">Swap PTGC</h2>
                    <p className="mb-2 w-100">Instantly swap tokens at the best rates with adjustable slippage tolerance.</p>
                    <hr className="my-2" />
                    {
                      sponsorName !=="" ?
                      <>
                      <div className="referInfo d-flex justify-content-between mb-3">
                        <p className="mb-1 " style={{width: '100px'}}><span className="op07 text-sm">Referred By:</span><br /> {sponsorName}</p>
                        <p className="mb-1 text-md-end "><span className="op07 text-sm">Referred Address:</span><br /> {truncateAddress(sponsorWallet)} {copied ? <i className="fa-solid fa-circle-check" style={{color: 'rgb(74 222 128 / 1)'}}></i> : <i className="fa-regular fa-copy" onClick={handleCopy}></i> }</p>
                      </div>
                      </>
                      :
                      <>
                      <div className="referInfo d-flex justify-content-between mb-3">
                        <p className="mb-1 " style={{width: '100px'}}><span className="op07 text-sm">Referred By:</span><br /> --</p>
                        <p className="mb-1 text-md-end "><span className="op07 text-sm">Referred Address:</span><br /> --</p>
                      </div>
                      </>
                    }
                    <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap ">
                        <p className=""><b>Quick Swap</b> <span className="byby">via PulseX</span></p>
                        <div className="position-relative" ref={dropdownRefSetting}>
                        {/* ⚙️ Icon */}
                        <button
                          className="btn btn-dark p-1"
                          style={{ borderRadius: "8px" }}
                          onClick={() => setOpen(!open)}
                        >
                          <i className="fa-solid fa-gear"></i>
                        </button>

                        {/* Dropdown */}
                        {open && (
                          <div
                            className="position-absolute end-0 mt-2 p-3  text-white"
                            style={{
                              width: "260px",
                              borderRadius: "12px",
                              border: "1px solid #2c2c2c",
                              zIndex: 1000,
                              background: '#1a1a1a'
                            }}
                          >
                            <h6 className="mb-2">Slippage Tolerance</h6>

                            <div className="d-flex gap-2 mb-2">
                              {[0.1, 0.5, 1.0].map((val) => (
                                <button
                                  key={val}
                                  className={`btn btn-sm ${
                                    slippage === val
                                      ? "btn-success btn-success-my"
                                      : "btn-outline-secondary btn-outline-secondary-my"
                                  }`}
                                  onClick={() => setSlippage(val)}
                                >
                                  {val}%
                                </button>
                              ))}
                              <input
                                type="text"
                                className="form-control form-control-sm bg-dark text-white"
                                placeholder="%"
                                style={{ width: "70px", borderColor: "#6c757d" }}
                                value={slippage}
                                inputMode="decimal"
                                onChange={(e) => {
                                  const value = e.target.value;

                                  if (!/^\d*\.?\d{0,2}$/.test(value)) return;

                                  if (value === "") {
                                    setSlippage("");
                                    return;
                                  }

                                  const num = Number(value);
                                  if (num <= 100) {
                                    setSlippage(value);
                                  }
                                }}
                              />
                            </div>
                            <p className="mb-0" style={{fontSize: '14px',lineHeight: '20px'}} >
                              Higher slippage increases success chance but may result in worse rates
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="swapInsn mb-3">
                        <div className="d-flex justify-content-between gap-1 flex-wrap">
                            <label>From</label>
                            <label>Balance: {parseFloat(PLSBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap inputimg">
                            <input
                              type="text"
                              placeholder='0.00'
                              value={
                                PLSAmount === "" || isNaN(Number(PLSAmount.toString().replace(/,/g, "")))
                                  ? ""
                                  : Number(PLSAmount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    })
                              }
                              onChange={async (e) => {
                                let raw = e.target.value.replace(/,/g, "");

                                if (raw === "") {
                                  await setPLSAmount("");
                                  return;
                                }

                                if (!/^\d*(\.\d{0,2})?$/.test(raw)) return;
                                const num = Math.min(Number(raw), Number(PLSBalance));
                                await setPLSAmount(num);
                              }}
                            />
                            <span><img src="./images/PLS.png" className="img-fluid" /> PLS</span>
                        </div>
                        <button className="swapIcon"><i className="fa-solid fa-rotate"></i></button>
                        <div className="d-flex justify-content-between gap-1 flex-wrap">
                            <label>To (estimated)</label>
                            <label>Balance: {parseFloat(PTGCBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap inputimg">
                            <input
                              type="text"
                              placeholder='0.00'
                              value={
                                PTGCAmount === "" || isNaN(Number(PTGCAmount.toString().replace(/,/g, "")))
                                  ? ""
                                  : Number(PTGCAmount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    })
                              }
                              disabled
                            />
                            <span><img src="./images/PTGC.png" className="img-fluid" /> PTGC</span>
                        </div>
                    </div>
                    <div className="swapInsn mb-3">
                        <div className="d-flex justify-content-between gap-1 flex-wrap mt-2">
                            <label>Rate</label>
                            <label style={{opacity:'1'}}>1 PLS ≈ {((1 * plsPrice) / ptgcPrice).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 8})} PTGC</label>
                        </div>
                        <div className="d-flex justify-content-between gap-1 flex-wrap">
                            <label>Slippage</label>
                            <label style={{opacity:'1'}}>{parseFloat(slippage).toFixed(2)}%</label>
                        </div>
                        <div className="d-flex justify-content-between gap-1 flex-wrap">
                            <label>Fee</label>
                            <label style={{opacity:'1'}}>0.3%</label>
                        </div>
                    </div>
                    <div className="someBtnsmod100 someBtns">
                      {
                        account ? 
                        <>
                        <button className="someSnbtn FFFFFF d-flex justify-content-between align-items-center mt-4" onClick={swapPTGC}>
                          <span>Swap Now</span> <div className="iconiconSR"> <img className="img-fluid" src="./images/circle_arrow.svg" /></div>
                        </button>
                        </>
                        :
                        <>
                        <button className="someSnbtn FFFFFF d-flex justify-content-between align-items-center mt-4" onClick={onConnect}>
                          <span>Connect Wallet</span> <div className="iconiconSR"> <img className="img-fluid" src="./images/circle_arrow.svg" /></div>
                        </button>
                        </>
                      }
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div className="col-lg-4">
          <div className="statsSN subcontent" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="400" style={{paddingBottom:"20px", minHeight:'auto'}}>
            <h2 className="gradient-stroke-text">PTGC Leaderboard </h2>
            <p className="mb-0">Discover your ranking and see how you stack up against other dedicated community members based on your efforts in community building and onboarding.</p>
            <div className="">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <button onClick={() => openModalWithTab("leaderboard")} className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                </div>
              </div>
            </div>
          </div>
          <div className="statsSN subcontent snX4 snX" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1400" style={{paddingBottom:"20px", minHeight: '340px'}}>
            <h2 className="gradient-stroke-text mb-1">Referral link</h2>
            <p className="mb-0">Generate your personalized referral link to climb the ranks within the community and earn potential rewards.</p>
                <div className="mt-3">
            {
              myName === "" ?
              <>
                <div className="CalculatorTop ">
                  <input
                    type="text"
                    className="input w-100 mb-2"
                    placeholder="Ex. @cryptoguru"
                    value={userName}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "") {
                        setUserName("");
                        return;
                      }

                      if (/^[a-zA-Z0-9_@\$&-]{0,20}$/.test(value)) {
                        setUserName(value);
                      }
                    }}
                  />
                </div>
                  <div className="someBtnsmod100 someBtns SRTOP  row justify-content-center">
                    <div className="col-12 col-lg-12 mb-2">
                      { 
                        account ? 
                        <>
                          <button className="borderbtn mybtn w-100 d-flex  justify-content-between align-items-center mt-1" onClick={generateLink}><span>Generate Referral Link</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                        </>
                        :
                        <>
                          <button className="borderbtn mybtn w-100 d-flex  justify-content-between align-items-center mt-1" onClick={onConnect}><span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                        </>
                      }
                    </div>
                  </div>
              </>
              :
              <>
              <div className="yourLink mt-2">
                <label className="op07 text-sm">Your Referral Link:</label>
                <p className="mb-0 text-white wordbreak">{baseurl+myName}</p>
              </div>
              </>
            }
                </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      <ContentModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <TransactionStatus/>
  </>
  );
};

export default Sections2;